import React from 'react';
import { Masks } from 'shared/helpers';
import propTypes from 'prop-types';

import Styles from './Table.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import WithPermission from 'components/Template/WithPermission/WithPermission';

export default function Table({ renderables, produtos, selector, tableRef }) {
  const { Table, Row, w150 } = Styles;
  const { number } = Masks;
  return (
    <div className={Table} ref={tableRef}>
      <header>
        <div className={w150}>Nome</div>
        <div className={w150}>Marca/Fornecedor</div>
        <div className={w150}>N Total</div>
        {renderables.map(renderable => (
          <div>{renderable}</div>
        ))}
        <div className={[w150, Styles.Hidden].join(' ')}>Edição</div>
      </header>
      <main>
        {produtos.map(produto => (
          <div className={Row}>
            <div className={w150} id={`produto_${produto.id || produtos._id}_nome`}>{produto.nome}</div>
            <div className={w150} id={`produto_${produto.id || produtos._id}_classificacao`}>{produto.classificacao}</div>
            <div className={w150} id={`produto_${produto.id || produtos._id}_N`}>
              {number(
                Number(produto.NO3) + Number(produto.NH2) + Number(produto.NH4),
                { suffix: '%', maxd: 2, mind: 2 },
              )}
            </div>
            {renderables.map(renderable => (
              <div id={`produto_${produto.id || produtos._id}_${renderable}`}>{number(produto[renderable], { suffix: '%', maxd: 4 })}</div>
            ))}
            <div className={[w150, Styles.Hidden].join(' ')}>
              <WithPermission permission='produtos.update'>
                <button id={`produto_${produto.id || produtos._id}_btn_editar`} onClick={() => selector({ ...produto })}>
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </WithPermission>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
}

Table.propTypes = {
  renderables: propTypes.array.isRequired,
  produtos: propTypes.any.isRequired,
  selector: propTypes.func.isRequired,
};
